import { BaseTextField } from '@evrone-erp/uikit';
import { styled } from '@mui/material';
import React from 'react';

import { hideMuiInputAdornmentIconSx } from '@shared/ui/commonSx';

type TReadOnlyInputProps = Parameters<typeof BaseTextField>[0];

export const ReadOnlyInput = styled((props: TReadOnlyInputProps) => (
  <BaseTextField
    InputProps={{
      readOnly: true,
      autoComplete: 'off',
    }}
    variant="filled"
    {...props}
  />
))(({ type, theme }) => ({
  pointerEvents: 'none',
  '& .MuiInputLabel-root': {
    ...theme.typography.caption,
  },
  '& .MuiInputLabel-root + .MuiInput-root': {
    marginTop: '10px',
  },
  '& .MuiInput-root::before': {
    display: 'none',
  },
  '& .MuiInput-root::after': {
    display: 'none',
  },
  ...(type === 'password' && hideMuiInputAdornmentIconSx),
}));

ReadOnlyInput.displayName = 'ReadOnlyInput';
